module.exports = __webpack_public_path__ + "static/media/masthead-midwest-times.4ac986f3.svg";